import React from 'react';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';

const LanguageSwitcher = ({ currentLang, onLanguageChange }) => {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onLanguageChange(currentLang === 'tr' ? 'en' : 'tr')}
        className="flex items-center gap-2 text-sm font-medium hover:bg-cream-100 transition-colors"
      >
        <Globe className="h-4 w-4" />
        <span>{currentLang === 'tr' ? 'EN' : 'TR'}</span>
      </Button>
    </div>
  );
};

export default LanguageSwitcher;